import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

export function QualifyingCriteria() {
  return (
    <section className="pt-10 pb-16 md:pt-14 md:pb-24 bg-[var(--vibe-color-background)]">
      <div className="max-w-3xl md:max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <RichTextContent
          path="qualifyingcriteria.blurb"
          label="Page Blurb"
          defaultValue="<p>Qualifying Rental Criteria</p><p>Touring: Government issued I.D is required to tour.</p><p>Income: Income verification is required during the application process.</p><p>Credit/Criminal: Unsatisfactory credit may require additional deposit &amp; criminal background checks are required.</p>"
          as="div"
          className="font-body text-sm sm:text-base leading-relaxed text-[var(--vibe-color-text-muted)] [&_p]:mb-4 [&_p:last-child]:mb-0"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'QualifyingCriteria',
  displayName: 'Qualifying Criteria',
  tokens: {
    'qualifyingcriteria.blurb': {
      label: 'Page Blurb',
      type: 'richtext',
      defaultValue:
        '<p>Qualifying Rental Criteria</p><p>Touring: Government issued I.D is required to tour.</p><p>Income: Income verification is required during the application process.</p><p>Credit/Criminal: Unsatisfactory credit may require additional deposit &amp; criminal background checks are required.</p>',
    },
  },
};

(QualifyingCriteria as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default QualifyingCriteria;
